import { Component, Input } from '@angular/core';
import { ResultType } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-simple-result-summary',
  templateUrl: './simple-result-summary.component.html'
})
export class SimpleResultSummaryComponent {
  @Input() resultType?: ResultType; 

  isShown(): boolean {
    return this.resultType !== undefined && 
      this.resultType !== ResultType.NoResults && 
      this.resultType !== ResultType.FinalResult;
  }
}
